<div class="wrapper" [ngClass]="wrapperClass">
    <div class="content">
        <ng-content class="content"></ng-content>
    </div>
    <div class="preview-selected hide-selector">&nbsp;</div>
</div>
